import { transientConversationFrameIds } from "@/lib/transient-conversation-frame";
import { useFramesStore } from "@/stores/frames-store";
import { usePresentationStore } from "@/stores/presentation-store";
import { useSelectionStore } from "@/stores/selection-store";
import { selectOrderedFrames } from "@/stores/frames-selectors";
import { discardFrames } from "@/lib/frame-ingest";

export function removeTransientConversationFramesFromCanvas(): boolean {
  const removedIds = transientConversationFrameIds(
    selectOrderedFrames(useFramesStore.getState()),
  );
  if (removedIds.size === 0) return false;

  // A presentation showing them ends with them; the frames store removal
  // then drops their nodes, edges and focus-hidden entries.
  useSelectionStore.getState().retain((id) => !removedIds.has(id));
  const { presentation, setPresentation } = usePresentationStore.getState();
  if (presentation?.frameIds.some((id) => removedIds.has(id))) {
    setPresentation(null);
  }
  discardFrames(removedIds);

  return true;
}
